import "./../../../node_modules/bootstrap/dist/js/bootstrap.min";
// // import "./../../../node_modules/bootstrap/js/src/index";

// import Alert from "../../../node_modules/bootstrap/js/src/alert";
// import Button from "../../../node_modules/bootstrap/js/src/button";
// import Carousel from "../../../node_modules/bootstrap/js/src/carousel";
// import Collapse from "../../../node_modules/bootstrap/js/src/collapse";
// import Dropdown from "../../../node_modules/bootstrap/js/src/dropdown";
// import Modal from "../../../node_modules/bootstrap/js/src/modal";
// import Popover from "../../../node_modules/bootstrap/js/src/popover";
// import Scrollspy from "../../../node_modules/bootstrap/js/src/scrollspy";
// import Tab from "../../../node_modules/bootstrap/js/src/tab";
// import Toast from "../../../node_modules/bootstrap/js/src/toast";
// import Tooltip from "../../../node_modules/bootstrap/js/src/tooltip";
// import Util from "../../../node_modules/bootstrap/js/src/util";

// /**
//  * --------------------------------------------------------------------------
//  * Bootstrap (v4.5.0): index.js
//  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
//  * --------------------------------------------------------------------------
//  */

// export {
//   Util,
//   Alert,
//   Button,
//   Carousel,
//   Collapse,
//   Dropdown,
//   Modal,
//   Popover,
//   Scrollspy,
//   Tab,
//   Toast,
//   Tooltip,
// };
